import Slider from './components/Slider';
import './components/datepicker.js';
import './components/gallery.js';
import { FormGuide, FormGuideDefaults } from "./components/form-guide.js";
import { SimpleGuests, SimpleGuestsDefaults } from "./components/simple-guests.js";
import inputPopover from "./components/input-popover.js";
import functions from "./functions.js";
import lozad from 'lozad';

SimpleGuestsDefaults.infantsAge = 6;

$(function () {

  $('body').on('click', '.dropdown-menu', e =>
  {
    e.stopPropagation();
  });

  $('#navMainMenu').on('show.bs.collapse', e => {
    $('.main-navbar').addClass('show');
  });
  $('#navMainMenu').on('hide.bs.collapse', e => {
    $('.main-navbar').removeClass('show');
  });

  if($(window).scrollTop() > 10) {
    $('.main-navbar').addClass('following');
  }

  const $scrollFadeTop = $('.scroll-fade-top');

  function scrollFadeTop() {
    const scrollTop = $(window).scrollTop();

    $scrollFadeTop.length && $scrollFadeTop.each((index, elem) => {
      const $elem = $(elem);

      if($elem.length && ! $elem.hasClass('start-animation') && ($elem.offset().top - scrollTop) < (functions.isMobile() ? 700 : 800)) {
        $elem.addClass('start-animation');

        /*for(let i = 1; i <= 4; i++) {
          const $photo = $elem.find('.photo-' + i);
          $photo.length && ! $photo.hasClass('start-animation') && $photo.addClass('start-animation');
        }*/
      }
    });
  }

  scrollFadeTop();

  $(window).scroll(e => {

    scrollFadeTop();

    ! $('body').hasClass('header-no-fixed') && $(window).scrollTop() > 10
        ? $('.main-navbar').addClass('following')
        : $('.main-navbar').removeClass('following');

  });

    // special offer slider
    $('[id^=card-slider]').each((i, elem) => {
      let $items = $(elem).find('.keen-slider__slide.card-slide');
      
      new Slider('#' + $(elem).attr('id'), {
          //items: $items,
          selector: '.keen-slider__slide.card-slide',
          loop: false,
          drag: $items.length > 3 ? true : false,
          arrows: true,
          pager: true,
          slides: {
              perView: 3,
              spacing: 0
          },
          breakpoints: {
              '(max-width: 1360px)': {
                  origin: 'center',
                  drag: true,
                  slides: {
                      perView: 2.2,
                      spacing: 0,
                  },
              },
              '(max-width: 991px)': {
                  origin: 'center',
                  drag: true,
                  slides: {
                      perView: 2.2,
                      spacing: 0,
                  },
              },
              '(max-width: 767px)': {
                  origin: 'center',
                  drag: true,
                  arrows: false,
                  slides: {
                      perView: 1.2,
                      spacing: 0,
                  },
              },
          },
      });

      $items.length && $items.first().addClass('active');
    });

    $('[id^=destinations-slider]').each((i, elem) => {
      let $items = $(elem).find('.keen-slider__slide');
      new Slider('#' + $(elem).attr('id'), {
          //items: $items,
          selector: '.keen-slider__slide',
          loop: true,
          drag: $items.length > 3 ? true : false,
          arrows: true,
          pager: true,
          slides: {
              perView: 4,
              spacing: 0
          },
          breakpoints: {
              '(max-width: 1360px)': {
                  origin: 'center',
                  drag: true,
                  loop: true,
                  slides: {
                      perView: 3.2,
                      spacing: 0,
                  },
              },
              '(max-width: 991px)': {
                  origin: 'center',
                  drag: true,
                  loop: true,
                  slides: {
                      perView: 2.2,
                      spacing: 0,
                  },
              },
              '(max-width: 767px)': {
                  origin: 'center',
                  drag: true,
                  loop: true,
                  arrows: false,
                  slides: {
                      perView: 1.2,
                      spacing: 0,
                  },
              },
          },
      });
    });

    /*const observerVillas = lozad('.card.card-accommodation', {
      rootMargin: '200px 200px',
      loaded: elem =>
      {
          
          let ss = [];
          $(elem).find('[id^=list-slider]').each((i, elem) =>
          {
              const $items = $(elem).find('.keen-slider__slide');
              ss[i] = new Slider('#' + $(elem).attr('id'), {
                  rubberband: false,
                  //items: $items,
                  drag: false,
                  loop: true,
                  arrows: true,
                  spacing: 0,
                  pager: true,
                  slides: {
                      perView: 3,
                      spacing: 0
                  },
              });
          });
          $(elem).triggerHandler('lozadLoaded');
      }
    });
    observerVillas.observe();*/

    let formGuide = [];
    $('.form-guide').each((i, elem) =>{
      formGuide[i + 1] = new FormGuide(elem);
    });

    $('.simple-guests').each((i, elem) => {
      elem._simpleGuests = new SimpleGuests(elem, {
        btnValueTpl: (adults, children, infants, extras) => {
          return `${adults + children + infants} ${guestsTranslations[language].guests}${extras ? ', ' + extras + ' ' + guestsTranslations[language].infants : ''}`;
        }
      });
    });

    inputPopover.apply();

  $('.read-more-action').on('click', e => {
    const $target = $(e.currentTarget);
    const $readMoreWrapper = $target.parents('.read-more-wrapper');
    const $readMoreContent = $readMoreWrapper.find('.read-more-content');
    const isExpanded = $readMoreContent.hasClass('expand');
    const $readMoreText = $target.find('.read-more-text');

    $readMoreContent.toggleClass('expand', ! isExpanded);
    $target.toggleClass('read-less', ! isExpanded);
    $readMoreText.text(isExpanded ? 'Pročitaj više' : 'Prikaži manje');

    functions.isMobile() && isExpanded && functions.scrollToElement($readMoreWrapper, 100);
  });

  // scrool to element handling
  $(document).on('click', '[data-scroll-to]', e => {
      e.preventDefault();
      const $this = $(e.target);
      let scrollTo = $this.attr('data-scroll-to').split(',');
      functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
  });
});